import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProjectAuditTrail({ projectId }) {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    if (open && entries === null) {
      axios.get(`${API}/projects/${projectId}/audit`)
        .then(r => setEntries(r.data.entries || []))
        .catch(() => setEntries([]));
    }
  }, [open, entries, projectId]);

  return (
    <div className="realease-card overflow-hidden" data-testid="project-audit-trail">
      <button onClick={() => setOpen(o => !o)}
              className="w-full flex items-center justify-between px-4 py-2.5 text-left hover:bg-gray-50"
              data-testid="audit-trail-toggle">
        <span className="flex items-center gap-2 text-sm font-semibold text-gray-800">
          <svg className="w-4 h-4 text-[#13736D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Historique des actions du dossier
        </span>
        <span className="flex items-center gap-2 text-xs text-gray-400">
          {entries !== null && `${entries.length} action(s)`}
          <svg className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="border-t border-gray-100 max-h-80 overflow-y-auto" data-testid="audit-trail-list">
          {entries === null && <p className="p-4 text-xs text-gray-400">Chargement...</p>}
          {entries !== null && entries.length === 0 && (
            <p className="p-4 text-xs text-gray-400">Aucune action tracée pour l'instant — les prochaines modifications du dossier apparaîtront ici.</p>
          )}
          {(entries || []).map(e => (
            <div key={e.audit_id} className="px-4 py-2 border-b border-gray-50 text-xs flex items-start gap-3" data-testid="audit-entry">
              <span className="text-gray-400 whitespace-nowrap tabular-nums">
                {new Date(e.at).toLocaleDateString('fr-FR')} {new Date(e.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
              </span>
              <span className="font-semibold text-[#13736D] whitespace-nowrap">{e.user_name}</span>
              <span className="text-gray-700">
                <b>{e.action}</b>{e.details && <span className="text-gray-500"> — {e.details}</span>}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
